module.exports = __webpack_public_path__ + "static/process-detail-4a.eb4617c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-4a.png
// module id = 1493
// module chunks = 214286880276331